import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Container,
    Typography,
    useMediaQuery,
    CircularProgress,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { db } from "../../firebase";
import { collection, getDocs, query, limit, orderBy, startAfter } from "firebase/firestore";

import { Helmet } from "react-helmet-async";

import InfiniteScroll from "react-infinite-scroller";

import EditIcon from "@mui/icons-material/Edit";

import { useNavigate } from "react-router-dom";

function Video() {
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    const [videoData, setVideoData] = useState([]);

    const [hasMore, setHasMore] = useState(true);
    const [lastVisible, setLastVisible] = useState(null);

    const isSP = useMediaQuery("(max-width:600px)");
    const cardWidth = isSP ? 170 : 350;
    const mediaHeight = isSP ? 192.375 : 288.7481;
    const cardMx = isSP ? 1 : 2;
    const footerHeight = isSP ? 56 : 64;

    const handleTransVideo = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const videoRef = collection(db, "video");

        try {
            const q = query(videoRef, orderBy("createAt", "desc"), limit(10));
            const videoSnap = await getDocs(q);

            if (videoSnap.empty) {
                setHasMore(false);
                setLoading(false);
                return;
            }

            const videos = [];
            videoSnap.forEach((doc) => {
                videos.push({
                    img: doc.data().img,
                    id: doc.data().id,
                    title: doc.data().title,
                    description: doc.data().description,
                    complete: doc.data().complete,
                    episode: doc.data().episode,
                    release: doc.data().release,
                });
            });
            setVideoData(videos);

            setLastVisible(videoSnap.docs[videoSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }

        setLoading(false);
    };

    const fetchMoreData = async () => {
        const videoRef = collection(db, "video");

        try {
            const q = query(videoRef, orderBy("createAt", "desc"), limit(10), startAfter(lastVisible));
            const videoSnap = await getDocs(q);

            if (videoSnap.empty) {
                setHasMore(false);
                return;
            }

            const videos = [];
            videoSnap.forEach((doc) => {
                videos.push({
                    img: doc.data().img,
                    id: doc.data().id,
                    title: doc.data().title,
                    description: doc.data().description,
                    complete: doc.data().complete,
                    episode: doc.data().episode,
                    release: doc.data().release,
                });
            });
            setVideoData((prevData) => [...prevData, ...videos]);

            setLastVisible(videoSnap.docs[videoSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }
    };

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Movie List - SOG Member Site</title>
                <meta name="description" content="最強絶頂集団のメンバーで投稿した動画リストです。" />
                <meta name="keywords" content="TRPG, 最強絶頂集団, SOG, 動画リスト, 動画" />

                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Box sx={{ display: "flex", flexDirection: "column", minHeight: `calc(100vh - ${footerHeight}px)` }}>
                <Container component="main" maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                    <Box
                        sx={{ mt: 2 }}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <Typography variant="h6" component="h1">
                            動画リスト
                        </Typography>
                    </Box>
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={fetchMoreData}
                        hasMore={hasMore}
                        loader={
                            <Box
                                sx={{ m: 1 }}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                                key={0}
                            >
                                <CircularProgress />
                            </Box>
                        }
                    >
                        <Grid
                            container
                            sx={{ mt: 2 }}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {videoData.map((item) => (
                                <Grid
                                    item
                                    key={item.id}
                                    xs={12}
                                    sm={5}
                                    sx={{
                                        minWidth: cardWidth,
                                        my: 1,
                                        mx: cardMx,
                                    }}
                                >
                                    <Card sx={{ position: "relative" }}>
                                        <CardMedia
                                            component="img"
                                            height={mediaHeight}
                                            image={item.img}
                                            alt={item.title}
                                            sx={{
                                                objectFit: "contain",
                                            }}
                                        />
                                        <IconButton
                                            sx={{
                                                position: "absolute",
                                                top: 8,
                                                right: 8,
                                                color: "white",
                                            }}
                                            onClick={() => navigate(`/video/${item.id}`)}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                        <CardContent>
                                            <Typography
                                                variant="body1"
                                                component="h2"
                                                sx={{
                                                    height: 50,
                                                    mb: 1,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: "2",
                                                    WebkitBoxOrient: "vertical",
                                                    overflowWrap: "break-word",
                                                    whiteSpace: "pre-wrap",
                                                }}
                                            >
                                                {item.title}
                                            </Typography>
                                            <Accordion disableGutters elevation={0} square>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    sx={{
                                                        backgroundColor: "rgba(12, 12, 12, .3)",
                                                    }}
                                                >
                                                    <Typography variant="body2">あらすじ</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails
                                                    sx={{
                                                        backgroundColor: "rgba(12, 12, 12, .3)",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            overflowWrap: "break-word",
                                                            whiteSpace: "pre-wrap",
                                                        }}
                                                    >
                                                        {item.description}
                                                    </Typography>
                                                </AccordionDetails>
                                            </Accordion>
                                        </CardContent>
                                        <CardActions
                                            sx={{
                                                justifyContent: "space-between",
                                                display: "flex",
                                                alignItems: "center",
                                                ml: 1,
                                            }}
                                        >
                                            {item.complete ? (
                                                <Typography variant="body2">全{item.episode}話</Typography>
                                            ) : (
                                                <Typography variant="body2">未完結</Typography>
                                            )}
                                            {item.release ? (
                                                <Button color="primary" onClick={() => handleTransVideo(item.url)}>
                                                    WATCH NOW!!!
                                                </Button>
                                            ) : (
                                                <Button disabled>視聴することができません</Button>
                                            )}
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </InfiniteScroll>

                    <Box sx={{ mb: 5 }} />
                </Container>
            </Box>
        </div>
    );
}

export default Video;
